import { render, staticRenderFns } from "./Alibaba-order-info.vue?vue&type=template&id=88f87e0c&"
import script from "./Alibaba-order-info.vue?vue&type=script&lang=js&"
export * from "./Alibaba-order-info.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-order-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports